module.exports = __webpack_public_path__ + "static/img/login-kouhao.5ceca6b5.png";